import React from "react";
import Footer from "../Sub/Footer";
import { Col, Row } from "react-bootstrap";
import Header from "../Sub/Header";
import LastLocation from "../Sub/LastLocation";
import NavbarWithDrawer from "../Sub/NavbarWithDrawer";

const About = () => {
  let width = window.innerWidth;
  return (
    <>
     {/* <Row className="bg-themesecond shadow-none p-2 align-items-center">
            <Col md={1} sm={1} xs={1}>
              <h4 className="mb-0">
                <LastLocation />
              </h4>
            </Col>
          </Row> */}
          <NavbarWithDrawer/>
      {/* <Header /> */}
      <div className="container-fluid mt-5 pt-3">
        <div className={`page-main ${width >= 468 && "p-5"}`}>
          <Row>
            <h1 className="mb-4">ABOUT US</h1>
            <p>
            {process.env.REACT_APP_SITE_NAME} is a secure and private messaging app designed for structured communication between users and group leaders.
            </p>
            <p className="mt-2 mb-0">Key Features:</p>
            <ul>
              <li>OTP-based login</li>
              <li>Chat with text, photos, videos, and links</li>
              <li>Multi-device support</li>
              <li>No user-to-user chatting (only with assigned leaders)</li>
              <li>No ads or in-app purchases</li>
            </ul>
          </Row>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default About;
